import { Box, Paper, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';
import TransactionItem from './transaction-item.component';
import { TransactionOrderItem } from 'api/transactions/transactions.types';

const TransactionItems = ({
  displayName,
  quantity,
  unitPrice,
  total,
  dicountTotal,
  taxTotal,
  voided,
  voidInfo,
}: TransactionOrderItem) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Paper
      elevation={4}
      sx={{
        padding: 2,
        marginTop: 1,
        marginBottom: 1,
        borderLeftWidth: 3,
        borderLeftColor: theme.palette.primary.main,
        borderLeftStyle: 'solid',
      }}
      data-testid="TransactionItems.Card"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        data-testid="TransactionItems.Card.Title"
      >
        <Stack direction="row" spacing={1}>
          <Typography variant="h4">{`${quantity}x`}</Typography>
          <Typography variant="h4">{displayName}</Typography>
        </Stack>
        <Typography variant="h4">{formatCurrency(total)}</Typography>
      </Box>
      <TransactionItem
        label={t('drawer.transactionDetailsDrawer.itemInfo.price.label')}
        value={formatCurrency(unitPrice)}
      />
      <TransactionItem
        label={t('drawer.transactionDetailsDrawer.itemInfo.discount.label')}
        value={formatCurrency(dicountTotal)}
      />
      <TransactionItem
        label={t('drawer.transactionDetailsDrawer.itemInfo.tax.label')}
        value={formatCurrency(taxTotal)}
      />
      <TransactionItem
        label={t('drawer.transactionDetailsDrawer.itemInfo.voided.label')}
        value={!!voided ? 'True' : 'False'}
      />
      {voided && (
        <TransactionItem
          label={t('drawer.transactionDetailsDrawer.itemInfo.reason.label')}
          value={voidInfo?.voidReason}
        />
      )}
    </Paper>
  );
};

export default TransactionItems;
